(function () {
  const UK_HOST = 'paintingbynumbers-expert.co.uk';

  if (window.__peUkRuntimeSanitize || window.location.hostname.indexOf(UK_HOST) === -1) return;
  window.__peUkRuntimeSanitize = true;

  const TEXT_REPLACEMENTS = [
    [/Homepagina/g, 'Home'],
    [/Klantbeoordelingen/g, 'Customer reviews'],
    [/Veelgestelde Vragen-pagina/g, 'Frequently Asked Questions page'],
    [/Veelgestelde Vragen/g, 'Frequently Asked Questions'],
    [/Bekijk dan eerst onze/g, 'Please check our'],
    [/Hier vind je antwoorden op bijna alle veelvoorkomende vragen, zoals/g, 'It covers most common questions, including'],
    [/Schrijf een beoordeling/g, 'Write a review'],
    [/(\d+)\s+beoordelingen/g, '$1 reviews'],
    [/(\d+)\s+beoordeling/g, '$1 review'],
    [/beoordelingen/g, 'reviews'],
    [/beoordeling/g, 'review'],
    [/Meest recent/g, 'Most recent'],
    [/Hoogste review/g, 'Highest rating'],
    [/Laagste review/g, 'Lowest rating'],
    [/Alleen foto's/g, 'Photos only'],
    [/Foto's eerst/g, 'Photos first'],
    [/Video's eerst/g, 'Videos first'],
    [/Meest nuttig/g, 'Most helpful'],
    [/Goede communicatie tijdens de corona tijden/g, 'Good communication during the COVID period'],
    [/Ik heb mijn product helemaal nooit ontvangen/g, 'I never received my product'],
    [/Groet hanneke/g, 'Regards, Hanneke'],
    [/Wacht, vergeet deze niet/g, "Wait, don't forget these"],
    [/Wilt u tot wel 15% korting/g, 'Want up to 15% off'],
    [/op uw eerste order\\?/g, 'on your first order?'],
    [/CLAIM 15% KORTING/g, 'CLAIM 15% OFF'],
    [/NEE, BEDANKT!/g, 'NO, THANKS!'],
    [/korting/g, 'discount'],
    [/Toevoegen/g, 'Add'],
    [/Toegevoegd/g, 'Added'],
    [/Doorgaan met mijn aankoop/g, 'Continue with my purchase'],
    [/Aanbieding wordt toegevoegd/g, 'Offer is being added'],
    [/Aanbiedingen toegevoegd/g, 'Offers added'],
    [/Je product wordt toegevoegd/g, 'Your product is being added'],
    [/Kies een geldige combinatie om verder te gaan/g, 'Choose a valid combination to continue'],
    [/Deze combinatie is momenteel niet beschikbaar/g, 'This combination is currently unavailable'],
    [/Uitverkocht/g, 'Sold out'],
    [/Voeg toe aan winkelmand/g, 'Add to cart'],
    [/In mijn winkelwagen/g, 'Add to cart'],
    [/Winkelwagen/g, 'Cart'],
    [/winkelwagen/g, 'cart'],
    [/Afrekenen/g, 'Checkout'],
    [/Verder winkelen/g, 'Continue shopping'],
    [/Bestel 3 schilderijen, betaal er 2/g, 'Order 3 kits, pay for 2'],
    [/2\+1 GRATIS/g, '2+1 FREE'],
    [/Gratis verzending/g, 'Free UK delivery'],
    [/gratis verzending/g, 'free UK delivery'],
    [/Verzending/g, 'Delivery'],
    [/verzending/g, 'delivery'],
    [/Bestelling/g, 'Order'],
    [/bestelling/g, 'order'],
    [/Nederland/g, 'the UK'],
    [/Belgie/g, 'the UK'],
    [/België/g, 'the UK'],
    [/Schilderen op nummer/g, 'Paint by Numbers'],
    [/schilderen op nummer/g, 'Paint by Numbers'],
    [/Schilderen op Nummer/g, 'Paint by Numbers'],
    [/Verven op nummer/g, 'Paint by Numbers'],
    [/verven op nummer/g, 'Paint by Numbers'],
    [/Eigen foto/g, 'Custom photo'],
    [/eigen foto/g, 'custom photo'],
    [/Volwassenen/g, 'Adults'],
    [/volwassenen/g, 'adults'],
    [/Kinderen/g, 'Children'],
    [/kinderen/g, 'children'],
    [/Kleuren/g, 'Colours'],
    [/kleuren/g, 'colours'],
    [/kleur/g, 'colour'],
    [/fromminimum/g, 'for at least'],
    [/paintingof/g, 'painting of'],
    [/same aspaint/g, 'same as paint'],
    [/isa very/g, 'is a very'],
  ];

  const URL_REPLACEMENTS = [
    ['/collections/schilderen-op-nummer-mini', '/collections/mini-paint-by-numbers'],
    ['/collections/schilderen-op-nummer', '/collections/paint-by-numbers'],
    ['/collections/meest-verkochte-producten', '/collections/best-sellers'],
    ['/collections/schilderen-op-nummer-populairste', '/collections/most-popular-paint-by-numbers'],
    ['/collections/schilderen-op-nummer-aanbiedingen', '/collections/offers'],
    ['/collections/dieren', '/collections/animal'],
    ['/collections/bloemen-planten', '/collections/flowers-plants'],
    ['/collections/overige-dieren', '/collections/other-animals'],
    ['/collections/schildpadden', '/collections/turtle'],
    ['/collections/vlinders', '/collections/butterfly'],
    ['/collections/honden', '/collections/dog-2'],
    ['/collections/hond', '/collections/dog-2'],
    ['/collections/kat', '/collections/cat'],
    ['/collections/apen', '/collections/monkey'],
    ['/collections/leeuwen', '/collections/lion'],
    ['/collections/olifanten', '/collections/elephant'],
    ['/collections/herten', '/collections/deer-2'],
    ['/collections/natuur-landschappen', '/collections/nature-landscape-paint-by-numbers'],
    ['/products/schilderen-op-nummer-eigen-foto', '/products/own-photo-paint-by-numbers'],
    ['/products/diamond-painting-eigen-foto', '/products/diamond-painting-custom-photo'],
    ['/products/schilderen-op-nummer-opgewekte-kat', '/products/excited-cat-paint-by-numbers'],
    ['/products/schilderen-op-nummer-gekleurde-leeuwen', '/products/coloured-lion-paint-by-numbers'],
    ['/products/schilderen-op-nummer-olifant-3', '/products/elephant-paint-by-numbers'],
    ['/products/schilderen-op-nummer-aap-1', '/products/monkey-paint-by-numbers'],
    ['/products/schilderen-op-nummer-vlinder', '/products/butterfly-paint-by-numbers'],
    ['/pages/veelgestelde-vragen', '/pages/frequently-asked-questions'],
    ['/pages/bestelling-levering', '/pages/orders-and-delivery'],
    ['/pages/retour-annuleringsbeleid', '/pages/returns-and-cancellations'],
    ['/pages/privacyverklaring-cookies', '/pages/privacy-and-cookie-policy'],
    ['/pages/algemene-voorwaarden', '/pages/terms-and-conditions'],
    ['/pages/volwassenen', '/pages/adults'],
    ['/pages/kind', '/pages/kids'],
    ['/pages/over-ons', '/pages/about-us'],
    ['/blogs/nieuws', '/blogs/blog'],
  ];

  const BLOCKED_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);

  function replaceText(value) {
    return TEXT_REPLACEMENTS.reduce((result, pair) => result.replace(pair[0], pair[1]), value);
  }

  function rewriteUrl(value) {
    if (!value || /^(mailto:|tel:|sms:|#)/i.test(value)) return value;

    let result = value;

    if (result.indexOf('app.judge.me/reviews/stores/paintingexpert.nl') !== -1) {
      return `${window.location.pathname}#judgeme_product_reviews`;
    }

    result = result
      .replace(/https?:\/\/www\.paintingexpert\.nl/gi, `https://${UK_HOST}`)
      .replace(/https?:\/\/paintingexpert\.nl/gi, `https://${UK_HOST}`)
      .replace(/https?:\/\/painting-expert\.myshopify\.com/gi, `https://${UK_HOST}`)
      .replace(/\/en\//g, '/');

    URL_REPLACEMENTS.forEach(([from, to]) => {
      result = result.replaceAll(from, to);
    });

    return result;
  }

  function sanitizeTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        const parent = node.parentElement;
        if (!parent || BLOCKED_TAGS.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const next = replaceText(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  }

  function sanitizeAttributes(root) {
    root.querySelectorAll('[href], [action], [title], [aria-label], [alt], [placeholder], option').forEach((node) => {
      ['title', 'aria-label', 'alt', 'placeholder'].forEach((attr) => {
        const value = node.getAttribute(attr);
        if (value) node.setAttribute(attr, replaceText(value));
      });

      ['href', 'action'].forEach((attr) => {
        const value = node.getAttribute(attr);
        if (value) node.setAttribute(attr, rewriteUrl(value));
      });

      if (node.tagName === 'OPTION' && node.textContent) {
        node.textContent = replaceText(node.textContent);
      }
    });
  }

  function sanitize(root) {
    if (!root) return;
    sanitizeTextNodes(root);
    sanitizeAttributes(root);
  }

  function scheduleSanitize(root) {
    window.clearTimeout(scheduleSanitize.timer);
    scheduleSanitize.timer = window.setTimeout(() => sanitize(root || document.body), 80);
  }

  function boot() {
    if (boot.started) return;

    if (!document.body) {
      window.setTimeout(boot, 50);
      return;
    }

    boot.started = true;
    window.peUkSanitize = () => sanitize(document.body);
    sanitize(document.body);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData' && mutation.target.parentElement) {
          const next = replaceText(mutation.target.nodeValue || '');
          if (next !== mutation.target.nodeValue) mutation.target.nodeValue = next;
          continue;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && node.parentElement) {
            const next = replaceText(node.nodeValue || '');
            if (next !== node.nodeValue) node.nodeValue = next;
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            scheduleSanitize(node);
          }
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    let scanCount = 0;
    const lateScan = window.setInterval(() => {
      sanitize(document.body);
      scanCount += 1;
      if (scanCount >= 30) window.clearInterval(lateScan);
    }, 500);

    window.addEventListener('load', () => scheduleSanitize(document.body), { once: true });
    document.addEventListener('shopify:section:load', () => scheduleSanitize(document.body));
    document.addEventListener('theme:cart:open', () => scheduleSanitize(document.body));
    document.addEventListener('theme:cart:update', () => scheduleSanitize(document.body));
    document.addEventListener('theme:product:added', () => scheduleSanitize(document.body));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
    window.setTimeout(boot, 500);
  } else {
    boot();
  }
})();
